<template>
  <div class="slb">
    <div class="page-title">{{name}}</div>
    <div class="nav-tab">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane :label="$t('user.profile')" name="userinfo"></el-tab-pane>
        <el-tab-pane :label="$t('user.log')" name="log"></el-tab-pane>
        <el-tab-pane label="Authentication" name="auth"></el-tab-pane>
      </el-tabs>
    </div>
    <router-view />
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeName: "info",
      name:'',
      timer:'',
    };
  },
  watch: {
    $route: {
      handler(val, oldval) {
        this.activeName = val.meta.tab;
      },
      immediate: true,
      deep: true,
    },
  },

  methods: {
      handleClick(tab) {
        let path = tab.name;
        this.$router.push({ path: `${path}` });
      },
      getNickname(){
          this.name = localStorage.getItem('inl_user_nicknname');
      }
  },
    created() {
        this.timer = setInterval(this.getNickname, 1000);
    },
    destroyed() {
        clearInterval(this.timer);
    }
};
</script>
<style scoped lang="scss">
.page-title {
  font-size: 24px;
  font-weight: 500;
  color: #0f1e33;
  line-height: 24px;
}
.nav-tab {
  margin: 12px -32px 48px;
}
.server {
  height: 100%;
}

</style>





// WEBPACK FOOTER //
// src/pages/user/Index.vue